import style from './index.module.scss';
import SubMenu from './SubMenu';
import { useMediaQuery, Collapse } from '@material-ui/core';
import { useState } from 'react';
import { ReactComponent as Cross } from './close.svg';
import { ReactComponent as Line } from './line.svg';

function NavMenu({ menu , currentPage }) {
    const isDesktop = useMediaQuery(`(min-width: calc(${style.laptopBreakpoint} + 1px))`);

    //binary mask to know wich menu is in open state
    const [openMenus, setOpenMenus] = useState(0);

    return (
        <ul className={style.menuGrid}>
            {menu &&
                Object.values(menu).map((menuItem, id) => {
                    return (
                        <li key={id} className={style.menuContainer}>
                            <div className={style.firstLvlContainer}>
                                {!isDesktop &&
                                    (menuItem.children?.length > 0 ? (
                                        <Cross
                                            className={(openMenus & Math.pow(2, id)) !== 0 && style.cross}
                                            onClick={() => {
                                                setOpenMenus(openMenus ^ Math.pow(2, id));
                                            }}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    ) : (
                                        <Line className={style.line} />
                                    ))}

                                <a 
                                    href={menuItem.url === '#' ? undefined : menuItem.url}
                                    className={style.menuItem} 
                                    style={menuItem.url === currentPage ? {textDecoration : "underline"} : {}}
                                >
                                    {menuItem.title}
                                </a>
                            </div>

                            {menuItem.children?.length > 0 &&
                                (isDesktop ? (
                                    <div className={style.subMenuContainer}>
                                        <SubMenu subMenu={menuItem.children} currentPage={currentPage} />
                                    </div>
                                ) : (
                                    <Collapse in={(openMenus & Math.pow(2, id)) !== 0}>
                                        <SubMenu subMenu={menuItem.children} currentPage={currentPage}/>
                                    </Collapse>
                                ))}
                        </li>
                    );
                })}
        </ul>
    );
}

export default NavMenu;
